import { render, staticRenderFns } from "./LicenseExceedsCourseSizeConfirmationModal.vue?vue&type=template&id=6bd1e000&"
import script from "./LicenseExceedsCourseSizeConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./LicenseExceedsCourseSizeConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseExceedsCourseSizeConfirmationModal.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports